import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import VideoGallerySliderModal from "./component";
import { withRouter } from "react-router-dom";
import withLogin from "../with-login";
import withWishlist from "../with-wishlist";
import { getIsStraightThroughEligble, getOrderDetail, getTradeInDetails, setCheckoutLoginType, updateOrder, updateValidC2bOrder } from "../checkout-info/actions";
import { clearSimilarCarList, fetchCarDetails, prePopulateCarDetails, setGsGalleryData } from "../car-details/actions";

const mapStateToProps = ({
    carDetails: { content },
    user: {
        secureToken,
        isUserZeroDpVariant,
        gaId,
        email
    },
    checkout: {
        order: { orderId, financeProvider, financeOpted },
        order
    },
    preApprovalLoan: {
        preApproved,
        financeData: { preApprovalType }
    },
    abExperiment: {
        financeFirstCheckoutRevamp
    },
    tradeIn: {
        tradeInToggleSelected,
        userTradeInData
    }
}) => ({
    secureToken,
    orderId,
    preApproved,
    tradeInToggleSelected,
    financeProvider,
    isUserZeroDpVariant,
    financeFirstCheckoutRevamp,
    order,
    preApprovalType,
    financeOpted,
    userTradeInData,
    content,
    gaId,
    email
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateOrderConnect: updateOrder,
            getOrderDetailConnect: getOrderDetail,
            updateValidC2bOrderConnect: updateValidC2bOrder,
            setCheckoutLoginTypeConnect: setCheckoutLoginType,
            getIsStraightThroughEligbleConnect: getIsStraightThroughEligble,
            getTradeInDetailsConnect: getTradeInDetails,
            fetchCarDetailsConnect: fetchCarDetails,
            prePopulateCarDetailsConnect: prePopulateCarDetails,
            setGsGalleryDataConnect: setGsGalleryData,
            clearSimilarCarListConnect: clearSimilarCarList
        },
        dispatch
    );

export default withLogin(withWishlist(withRouter(connect(mapStateToProps, mapDispatchToProps)(VideoGallerySliderModal))));
